import React, { useEffect, useState } from 'react';

import Typography from '@material-ui/core/Typography';
import { makeStyles } from '@material-ui/core/styles';

import ControllerInput from './ControllerInput';

const useStyles = makeStyles(() => ({
  uploadLabel: {
    display: 'inline-block',
    marginTop: '8px',
    background: '#4CAF50',
    color: '#fff',
    padding: '6px 14px',
    borderRadius: '6px',
    cursor: 'pointer',
    fontWeight: 'bold',
    fontSize: '0.85rem',
  },
  preview: {
    display: 'block',
    maxWidth: '100%',
    maxHeight: '200px',
    objectFit: 'contain',
    marginTop: '8px',
    borderRadius: '8px',
    border: '1px solid #ddd',
  },
}));

// value pode ser: null | string (URL existente) | File (novo arquivo)
function FileInputBase({
  value,
  onChange,
  label = 'Imagem',
  caption = 'jpg, jpeg, png — máx. 5mb',
  accept = 'image/jpeg,image/png',
}) {
  const classes = useStyles();
  const [inputKey] = useState(Date.now());
  const [preview, setPreview] = useState(null);

  useEffect(() => {
    if (value instanceof File) {
      const url = URL.createObjectURL(value);
      setPreview(url);
      return () => URL.revokeObjectURL(url);
    }
    setPreview(typeof value === 'string' ? value : null);
    return undefined;
  }, [value]);

  const inputId = `file-input-${label.replace(/\s+/g, '-').toLowerCase()}`;

  return (
    <div style={{ marginTop: '12px' }}>
      <Typography variant="caption" color="textSecondary">
        {`${label}${caption ? ` (${caption})` : ''}`}
      </Typography>
      <br />
      <input
        id={inputId}
        type="file"
        accept={accept}
        style={{ display: 'none' }}
        key={inputKey}
        onChange={onChange}
      />
      <label htmlFor={inputId} className={classes.uploadLabel}>
        {value instanceof File ? 'Alterar imagem' : 'Escolher imagem'}
      </label>
      {value instanceof File && (
        <Typography variant="caption" style={{ marginLeft: '8px' }}>
          {value.name}
        </Typography>
      )}
      {preview && (
        <img src={preview} alt="Preview" className={classes.preview} />
      )}
    </div>
  );
}

function FileInput({
  name,
  group = 'default',
  priority = 1,
  visible = true,
  deps = [],
  disabled = false,
  ...props
}) {
  return (
    <ControllerInput
      name={name}
      group={group}
      priority={priority}
      deps={deps}
      disabled={disabled}
      visible={visible}
      adapterValueOnChange={(e) => e.target.files[0] || null}
      render={({ field }) => (
        <FileInputBase {...props} value={field.value} onChange={field.onChange} />
      )}
    />
  );
}

export default FileInput;
